import { FeatureFlagsConfig } from '@models/feature-flags-config';

export const features: FeatureFlagsConfig = {
    useNewDamageReportSummaryPage: true,
    portalMaintenanceMode: false,
    orderFormMaintenanceMode: false,
};
